import axios from "./axios.js";
let {get, post } = axios
// export const sendCaptcha = data => get("/captcha/sent",data)

export const apiGetZones = data => post("https://wx.ceteelv.cn/api/campus_agency_enter/zones",data)
export const apiApply = data => post("https://wx.ceteelv.cn/api/campus_agency_enter/apply",data)
